import { ofType } from "@ngrx/effects";
import { EffectPropertyKey } from "@ngrx/effects/src/models";
import { ActionCreator } from "@ngrx/store";
import { Subscription } from "rxjs";
import { tap } from 'rxjs/operators'
import { NgrxActions } from "../decorators.module";

export type onActionConfig = { actions: ActionCreator[] }
export const SUBSCRIPTION_KEYS = '__onAction_sub$';

export function OnAction(config: onActionConfig) {
  return function <T extends Object, K extends EffectPropertyKey<T>>(
    target: T,
    propertyKey: K,
    descriptor: PropertyDescriptor
  ) {

    const originalMethod = descriptor.value as Function;
    if (typeof originalMethod !== 'function') {
      throw new TypeError(
        `Unexpected type ${typeof originalMethod} of property ${propertyKey}, ` +
        `expected 'function'`
      );
    }

    const name = `${propertyKey}${SUBSCRIPTION_KEYS}`

    const originalNgOnInit = target.constructor.prototype['ngOnInit'];
    const originalNgOnDestroy = target.constructor.prototype['ngOnDestroy'];

    target.constructor.prototype['ngOnInit'] = function () {

      const { actions$ } = NgrxActions;

      if (actions$ === null) {
        throw new Error(`${NgrxActions.name} not connected to store!, Please ensure you are injecting NgrxHelperModule`);
      }

      const context = this;
      originalNgOnInit && originalNgOnInit.apply(context, arguments);

      const func = originalMethod.bind(context);

      const getSub = () => actions$.pipe(
        ofType(...[...config.actions]),
        tap((p) => {
          if (!!p) {
            func({ ...p })
            return;
          }
          func(null);
        })
      );

      context[name] = getSub().subscribe();
    }

    target.constructor.prototype['ngOnDestroy'] = function () {
      const context = this;
      originalNgOnDestroy && originalNgOnDestroy.apply(context, arguments);
      if (context[name] && (context[name] as Subscription).unsubscribe) {
        (context[name] as Subscription).unsubscribe();
      }
    }

  }

}
